import { render, staticRenderFns } from "./shangchuan_jichu.vue?vue&type=template&id=5fbabb90&scoped=true&"
import script from "./shangchuan_jichu.vue?vue&type=script&lang=js&"
export * from "./shangchuan_jichu.vue?vue&type=script&lang=js&"
import style0 from "./shangchuan_jichu.vue?vue&type=style&index=0&id=5fbabb90&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbabb90",
  null
  
)

export default component.exports